import { Popover, Slide } from '@mui/material';
import { motion } from 'framer-motion';
import { PopoverWrapperProps } from './popoverWrapper.types';

const MotionPopover = motion.create(Popover);

const transitionComponents = {
  slide: Slide,
};

const PopoverWrapper = ({
  anchorEl,
  children,
  isOpen,
  onClose,
  popoverOrigin,
  disableScrollLock,
  transitionComponent,
  transitionProps,
}: PopoverWrapperProps) => {
  const TransitionComponent = transitionComponent
    ? transitionComponents[transitionComponent]
    : undefined;

  return (
    <MotionPopover
      keepMounted
      open={isOpen}
      onClose={onClose}
      anchorEl={anchorEl}
      disableScrollLock={disableScrollLock}
      TransitionComponent={TransitionComponent}
      TransitionProps={transitionProps}
      transition={{ duration: 0.35, type: 'tween' }}
      anchorOrigin={
        popoverOrigin || {
          vertical: 'bottom',
          horizontal: 'center',
        }
      }
    >
      {children}
    </MotionPopover>
  );
};

export default PopoverWrapper;
